<template>
  <v-app :style="appBg">
    <!-- <ErrorPipelinePopup></ErrorPipelinePopup> -->
    <LegalDialog 
      v-if="showLegalDialog"
      title="Condiciones de venta" 
      v-model="sellTermsDialog"
    >
      <SaleTerms/>
    </LegalDialog> 
    <!-- <Keypress :key-code="13" event="keydown" @pressed="enter" /> -->
    <!--
    <Keypress :key-code="37" event="keydown" @pressed="previousLabel" />
    <Keypress :key-code="39" event="keydown" @pressed="nextLabel" />
    <Keypress :key-code="13" event="keydown" @pressed="enter" />
    <Keypress :key-code="46" event="keydown" @pressed="deleteLabel({ label: selectedLabel })" />
    <Keypress :key-code="key" event="keydown" @pressed="end" />-->
    <v-app-bar app class="appBar" height="75" dark clipped-left clipped-right v-if="showAppBar">
      <!-- <v-app-bar-nav-icon @click="drawer = !drawer" v-if="this.$router.currentRoute.name != 'login'" class="white--text"></v-app-bar-nav-icon> -->
      <v-app-bar-nav-icon v-once @click="drawer = !drawer" v-if="showBurger" class="white--text"></v-app-bar-nav-icon>
      <template v-if='userData' >
        <!-- <v-img v-if="domain.includes('docuxtract.docunecta.com')" :transition="false" :src="'/docunecta_logo.png'" contain :max-width="imgWidth" class="dragBar white__brand__logo" :class="{'mr-3': is_mobile}"></v-img>
        <v-img v-else-if="domain.includes('gscan.glasof.com')" :transition="false" :src="'/gscan_logo.png'" contain :max-width="imgWidth" class="dragBar white__brand__logo" :class="{'mr-3': is_mobile}"></v-img>
        <v-img v-else-if='userData.logo' :transition="false" :src="userData.logo" contain :max-width="imgWidth" class="dragBar white__brand__logo" :class="{'mr-3': is_mobile}"></v-img> -->
        <v-img v-if="appCustomLogo" :transition="false" :src="appCustomLogo" contain :max-width="imgWidth" class="dragBar white__brand__logo" :style="is_mobile?{height: '23px', width: '30px'}: {}"></v-img>
        <v-img v-else :transition="false" :src="imgSrc" contain :max-width="imgWidth" class="dragBar ml-2" :style="is_mobile?{height: '23px', width: '30px', marginRight: '3%'}: {}"></v-img>
      </template>
      <div v-if="got_feature('feature_simple_company_list')" style="padding-left: 30px;">
        <LanguageSwitcher/>
      </div>
      <v-spacer></v-spacer>
      <!-- Alerta puntos de carga -->
      <v-tooltip bottom v-if="showCDBSelector && showLoadPathAlert">
        <template v-slot:activator="{ on, attrs }">
          <v-icon large color="yellow" class="mx-2" v-bind="attrs" v-on="on" @click="openLoadPathAlert">
            mdi-alert
          </v-icon>
        </template>
        <span>Esta empresa tiene puntos de carga con errores.</span>
      </v-tooltip>
      <!-- Alerta empresa -->
      <v-tooltip bottom v-if="showCDBSelector && showCompanyAlert">
        <template v-slot:activator="{ on, attrs }">
          <v-icon large color="yellow" class="mx-2" v-bind="attrs" v-on="on">
            mdi-alert
          </v-icon>
        </template>
        <span v-html="linkErrorsWarning.tooltip"></span>
      </v-tooltip>
      <!-------------->
      <SelectorEmpresa
        name="SelectorEmpresa"
        v-if="showCDBSelector"
        :value="currentCompany"
        :items="activeCompanyDbs"
        @gotInput="updateCurrentCompany"
        @changed="set_suppliers"
        :readonly="isReadonlyCDBSelector"
        translate
      ></SelectorEmpresa>
      <v-btn
        v-if="!got_feature('feature_simple_company_list') && permission && (permission.general.can_admin || permission.is_employee) && showCDBSelector && !is_mobile"
        icon
        color="white"
        dark
        v-on:click="openEditCompanyDB"
      >
        <AppIcon src="/navigation/edit_square.svg" :size="29" class="img-top-navigation" />          
      </v-btn>
      <v-tooltip bottom v-if="got_feature('feature_sync_thirds_invoice_list') && permission && (permission.general.can_admin || permission.is_employee) && showCDBSelector && !is_mobile && currentCompany.id && refreshAccountsState != 'pending'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              color="white"
              dark
              v-bind="attrs" 
              v-on="on"
              @click="refresh_accounts()"
          >
            <v-icon v-once>
              mdi-account-convert
            </v-icon>
          </v-btn>
        </template>
        <span>Actualizar Proveedores y Clientes de la Empresa</span>
      </v-tooltip>
      <div v-if="got_feature('feature_sync_thirds_invoice_list') && permission && (permission.general.can_admin || permission.is_employee) && showCDBSelector && !is_mobile && refreshAccountsState === 'pending'" class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" />
      </div>
      <v-tooltip bottom v-if="got_feature('feature_autoflow_import_invoice') && permission && (permission.general.can_admin || permission.is_employee) && showCDBSelector && !is_mobile && currentCompany.id">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              color="white"
              dark
              v-bind="attrs"
              v-on="on"
              @click="create_autoflow_import_op()"
          >
            <v-icon v-once>
              mdi-tray-arrow-up
            </v-icon>
          </v-btn>
        </template>
        <span>Ejecutar importación de facturas automática</span>
      </v-tooltip>
      <v-tooltip bottom v-if="showForceDownloadLoadPathFiles">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              color="white"
              v-bind="attrs" 
              v-on="on"
              @click="forceDownloadLoadPath()"
              :loading="forceDownloadLoading"
          >
          <v-icon class="material-symbols-outlined">cloud_download</v-icon>
          </v-btn>
        </template>
        <span>Forzar descarga de los puntos de carga</span>
      </v-tooltip>
<!--       <v-progress-circular v-if="fetching_companydbs && $route.name!='login'" -->
      <v-progress-circular v-if="fetching_companydbs && showBtnGeneric"
        indeterminate
        color="secundary">
      </v-progress-circular>
      
      <v-spacer></v-spacer>
      <span v-if="this.currentCompany && this.currentCompany.available_features && (this.currentCompany.available_features.feature_kit_digital || this.currentCompany.available_features.feature_kit_digital_2)">{{ userData.business_name }}</span>
      <span style="display: contents;" v-if="this.currentCompany && this.currentCompany.available_features && !this.currentCompany.available_features.feature_kit_digital && !this.currentCompany.available_features.feature_kit_digital_2">
        <v-btn
          v-if="userData.is_staff && !is_mobile"
          v-on:click="change_debugger_mode"
          color="primary"
          elevation="0"
          
          style="background-color : transparent !important"
        >
          <div>
            <v-switch class="pt-6"
              v-model="user_data_can_debug_documents"
              :label="`DBM: ${user_data_can_debug_documents?'Sí':'No'}`"
            ></v-switch> 
          </div> 
        </v-btn> 
        <v-btn
          v-if="userData.is_staff && !is_mobile"
          v-on:click="change_trainer_mode"
          color="primary"
          elevation="0"
          style="background-color : transparent !important"
        >
          <div>
            <v-switch class="pt-6"
              v-model="user_data_can_see_training_documents"
              :label="`TM: ${user_data_can_see_training_documents?'Sí':'No'}`"
            ></v-switch> 
          </div> 
        </v-btn> 
        <v-btn
          v-if="got_feature('feature_connector_test') && !is_mobile" 
          rounded 
          class="text-none custom-btn" 
          @click="openPopup()"
        >
          <span class="custom-span">
            Test de Conector
          </span>
        </v-btn>
        <div v-if="isLoginas && userData.user_role.name!='Propietario'">{{ userData.user_role.name }}</div>
        <v-btn
          v-if="isLoginas"
          :color="get_color_loginas()"
          v-on:click="unset_loginas"
          class="black--text btn_without_caps"
          rounded
        >
          {{ loginasDisplayText }}
        </v-btn>
        &nbsp;&nbsp;

        <v-tooltip bottom v-if="isLoginas">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <AppIcon src="/navigation/location_home.svg" :size="29" class="img-top-navigation" :colorMap="{ '#FFFFFF': '#FFFFFF' }"/>
                </v-btn>
            </template>
            <span>{{userData.user_role.name}}</span>
        </v-tooltip>

        <v-btn
          v-if="isStaffOrStaffLoginas"
          icon
          color="white"
          dark
          :href="$router.resolve({name: 'debug'}).href"
          class="icon-btn-mobile"
        >
          <AppIcon src="/navigation/circle_settings.svg" :size="24" class="is_mobile? 'img-top-navigation-mobile' : 'img-top-navigation'" />
        </v-btn>
        <v-tooltip bottom v-if="isDistribuidorAvanzado">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="white"
              dark
              :href="$router.resolve({name: 'debug-distribuidor'}).href"
              class="icon-btn-mobile"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon :class="is_mobile? 'img-top-navigation-mobile' : 'img-top-navigation'">mdi-wrench</v-icon>
            </v-btn>
          </template>
          <span>Panel de soporte distribuidor</span>
        </v-tooltip>
        <v-btn
          v-if="this.userData.available_features.feature_user_notifications && notifications.length"
          icon
          color="#FFED00"
          dark
          v-on:click="show_notifications_modal = true"
        >
          <AppIcon src="/navigation/notifications.svg" :size="29" class="img-top-navigation" :preserveColors="true"/> 
        </v-btn>
        <v-btn
          v-if="(this.userData.available_features.feature_bank_contract_finished || this.userData.available_features.feature_defaulter_user || this.userData.available_features.feature_show_triangle_contracts || this.userData.available_features.feature_working_hours_contract_is_going_to_finish || this.userData.available_features.feature_working_hours_trial_contract_is_finished || this.userData.available_features.feature_working_hours_contract_finished) && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="var(--v-error-base)"
          dark
          v-on:click="openContractModal({'msg': 'Tu contrato ha expirado o ha excedido el número máximo de documentos. Para poder seguir utilizando Inmatic debes seleccionar un nuevo plan.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false})"
        >
          <v-icon v-once>
            mdi-alert
          </v-icon>
        </v-btn>
        <v-btn
          v-if="this.userData.available_features.feature_can_buy_facturae && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="var(--v-error-base)"
          dark
          v-on:click="openContractModal({'msg': 'Tu contrato de Facturas Electrónicas ha expirado o esta a punto de expirar.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false})"
        >
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn>
        <v-btn
          v-if="(this.userData.available_features.feature_bank_contract_is_going_to_finish ||this.userData.available_features.feature_contract_is_going_to_finish) && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="var(--v-error-base)"
          dark
          v-on:click="openContractModal({'msg': 'Tu contrato está a punto de expirar o de exceder el número máximo de documentos.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false})" 
        ><!-- TODO: REVISAR MENSAJE -->
          <v-icon v-once :style="is_mobile? {height: '25px', width: '25px'}:{}">
            mdi-alert
          </v-icon>  
        </v-btn> 
        <v-btn
          v-if="(this.userData.available_features.feature_bank_trial_contract_is_finished || this.userData.available_features.feature_trial_contract_is_finished) && this.userData.available_features.feature_payment_on_inmatic && !this.userData.sender_docs_user_distributor_code"
          icon
          color="var(--v-error-base)"
          dark          
          v-on:click="openContractModal({'msg': 'Tu contrato es de prueba, cuando expire el periodo de prueba o se excedan el número de documentos de prueba necesitarás contratar un plan.', 'distributor': false, 'facturae_client': false, 'is_company_selector_visible': false, 'is_tax_data_filled': false})"
        ><!-- TODO: REVISAR MENSAJE -->
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn>
        <v-btn
          v-if="this.userData.available_features.feature_accounting_stopped"
          icon
          color="#FFED00"
          dark
          v-on:click="show_accounting_critical_error_msg = true"
        >
          <v-icon v-once>
            mdi-alert
          </v-icon>  
        </v-btn> 

        <div v-if="!is_mobile">
          {{ session_information.username }}
        </div>
      </span>
      <v-menu
        v-if="showBtnGeneric"
        v-model="menu"
        :close-on-click="true"
        :close-on-content-click="false"
        offsetY
        class="menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            color="white"
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon v-once>
              mdi-account-circle-outline
            </v-icon>
            
          </v-btn>
        </template>

        <v-list id="account-menu" class="account-menu--custom">
          <v-list-item-group color="primary">
            <div v-for="(item, index) in user_items" :key="index">
              <v-list-group
                v-if="item.items"
                :value="false"
                no-action
                class="list-title"
                :class="{highlighted: item.highlighted, list: true}"
              >
                <template v-slot:activator>
                  <v-list-item-title class="list-title">{{ item.title }}</v-list-item-title>
                </template>
                <div v-for="(subitem, i) in item.items" :key="i">
                  <v-list-item
                    v-if="subitem.href"
                    :href="subitem.href"
                    :download="subitem.filename"
                    :class="{highlighted: subitem.highlighted, list: true}"
                    @click="menu=false"
                  >
                    <v-list-item-title class="list-title pl-4">{{ subitem.title }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-else
                    @click="subitem['click']()"
                    :class="{highlighted: subitem.highlighted, list: true}"
                  >
                    <v-list-item-title class="list-title pl-4">{{ subitem.title }}</v-list-item-title>
                  </v-list-item>
                </div>
              </v-list-group>
              <v-list-item
                v-else   
                @click="item['click']()"
                :class="{highlighted: item.highlighted, list: true}"
              >
              <!-- class="list" -->
                <v-list-item-title class="list-title">{{ $t("App."+changeLanguage(item.title)) }}<v-icon v-if="item.icon">{{item.icon}}</v-icon></v-list-item-title>
              </v-list-item>
            </div>
          </v-list-item-group>

        </v-list>
      </v-menu>
      <v-btn
          v-if="isElectron"
          icon
          dark
          v-on:click="electronReload()"
        >
          <v-icon v-once>
            mdi-reload
          </v-icon>  
        </v-btn>
        <v-btn
        v-if="got_feature('interactive_connector')&&isElectron && !interactiveConectorStarted"
        icon
        dark
        v-on:click="electronStartInteractiveConnector()"
      >
        <v-icon v-once>
          mdi-play
        </v-icon>  
      </v-btn>
      <v-btn
        v-if="got_feature('interactive_connector')&&isElectron && interactiveConectorStarted"
        icon
        dark
        v-on:click="electronStopInteractiveConnector()"
      >
        <v-icon v-once>
          mdi-stop
        </v-icon>  
      </v-btn>
      <v-btn
        v-if="isElectron"
        icon
        dark
        v-on:click="electronMinimize()"
      >
        <v-icon v-once>
          mdi-window-minimize
        </v-icon>  
      </v-btn> 
      <v-btn
        v-if="isElectron && maximized"
        icon
        dark
        v-on:click="electronRestore()"
      >
        <v-icon v-once>
          mdi-window-restore
        </v-icon>  
      </v-btn>   
      <v-btn
        v-if="isElectron && !maximized"
        icon
        dark
        v-on:click="electronMaximize()"
      >
        <v-icon v-once>
          mdi-window-maximize
        </v-icon>  
      </v-btn>  
      <v-btn
        v-if="isElectron"
        icon
        dark
        v-on:click="electronClose()"
      >
        <v-icon v-once>
          mdi-window-close
        </v-icon>  
      </v-btn> 
    </v-app-bar>
    <v-navigation-drawer 
      app 
      clipped 
      v-if="showLeftDrawer"
      v-model="drawer" 
      class="drawer main-left-drawer py-4"
      :mini-variant="isMini"
      mini-variant-width="90"
      :width="isMini ? '90' : '256'"
      :mobile-breakpoint="960" 
    >
      <template v-for="(zone,ind) in zones">
        <template v-if="ind<2 || (permission.can_write)">
          <v-list dense nav v-bind:key="zone.heading+'3'" class="ma-0 pa-0">
            <v-list-item-group class="ma-0 pa-0">
              <template v-for="(item, i) in zone.items">
                <sidebar-element v-if="item.shouldShow" :to="item.link" :key="i" :new_label="item.new_label" :icon_type="item.img? 'image' : 'icon'" :icon_src="item.img ? item.img : item.icon">
                  <template #text>
                    {{ getItemDisplayText(item) }}
                  </template>
                </sidebar-element>
              </template>
            </v-list-item-group>
          </v-list>
        </template>
      </template>
    </v-navigation-drawer>

    <!-- Right drawer -->
    <v-navigation-drawer
      app right 
      v-if="showRightBar && permission.can_write"
      v-model="drawer" 
      :width="got_feature('feature_new_invoice_page') ? '658' : '450'"
      clipped
      class="drawer"
      :class="got_feature('feature_new_invoice_page') ? 'transparent' : ''"
      mobile-breakpoint="0"
      
    >
      <!-- TODO: Check TrainerMode or ClientMode -->
      <RightDrawerTrainerMode v-if="documentIsDebuggerMode"></RightDrawerTrainerMode>
      <RightDrawerClientModeV2 v-else-if="got_feature('feature_new_invoice_page')" class="right-drawer-v2"></RightDrawerClientModeV2>
      <RightDrawerClientMode v-else ></RightDrawerClientMode>
      <account-move-v2 v-if="got_feature('feature_new_invoice_page') && permission.can_write &&  showRightBar && currentDoc && currentDoc.companydb_info.companydb_type.type == 'account_move'" :key="currentDoc.id"></account-move-v2>
    </v-navigation-drawer>

    

    <v-main>
      <router-view></router-view>
    </v-main>
    <!-- TODO: El tutorial es mejor que tenga el v-if=false hasta que este en uso -->
    <Tutorial v-if="false" />
    <invoice-lines v-if="false && got_feature('feature_invoice_lines') && permission.can_write &&  showRightBar && currentDoc && currentDoc.static_invoice" :key="'invoice_lines_'+currentDoc.id.toString()"/>
    <account-move v-if="!got_feature('feature_new_invoice_page') && permission.can_write &&  showRightBar && currentDoc && currentDoc.companydb_info.companydb_type.type == 'account_move'" :key="currentDoc.id"/>

    <contract-popup
      v-if="show_contract_modal"
    />
    <ExtraUserContractPopup
      v-if="is_visible_extra_user_contract_popup"
    />
    <PayChargePopup
      v-if="is_visible_pay_charge_popup"
    />
    <v-dialog v-model="show_notifications_modal" max-width="800" >
      <Notifications></Notifications>
    </v-dialog>
    <app-confirm-modal
          v-model="show_payment_error"
          :persistent="persistent_payment_error"
          :text-msg="text_payment_error"
          :text-center-msg="text_center_payment_error"
          :title-icon="icon_payment_error"
          :show-title="show_title_payment_error"
          :text-title="text_title_payment_error"
          :show-text-question="show_question_payment_error"
          :show-confirm-button="show_confirm_button_payment_error"
          :text-confirm-button="text_confirm_button_payment_error"
          @confirm="closePaymentErrorModal()"
          :show-cancel-button="show_cancel_button_payment_error"
          @cancel="closePaymentErrorModal()"></app-confirm-modal>
    <app-confirm-modal
            v-model="show_payment_ok"
            :persistent="persistent_payment_ok"
            :text-msg="text_payment_ok"
            :text-center-msg="text_center_payment_ok"
            :title-icon="icon_payment_ok"
            :show-title="show_title_payment_ok"
            :text-title="text_title_payment_ok"
            :show-text-question="show_question_payment_ok"
            :show-confirm-button="show_confirm_button_payment_ok"
            :text-confirm-button="text_confirm_button_payment_ok"
            @confirm="closePaymentOkModal()"
            :show-cancel-button="show_cancel_button_payment_ok"
            @cancel="closePaymentOkModal()"></app-confirm-modal>
  
    <app-confirm-modal 
      v-model="showMessageModal"
      :text-msg="textMessageModal"
      :text-center-msg="textCenterMessageModal"
      :title-icon="iconMessageModal"
      :show-title="showTitleMessageModal"
      :text-title="textTitleMessageModal"
      :text-confirm-button="textConfirmButtonMessageModal"
      :show-confirm-button="showConfirmButtonMessageModal"
      :show-cancel-button="showCancelButtonMessageModal"
      :text-cancel-button="textCancelButtonMessageModal"
      :show-text-question="showQuestionMessageModal"
      :text-question="textQuestionMessageModal"  
      :persistent="persistentMessageModal"
      :is-html="htmlMessageModal"
      @cancel="actionCancelButtonMessageModal"
      @confirm="actionConfirmButtonMessageModal"
    />
    <message-popup 
      v-if="show_accounting_critical_error_msg && userData.available_features.feature_accounting_stopped"
      title="Aviso" 
      message="Se ha detenido la contabilización debido a que hemos detectado un error crítico al contabilizar una factura. Por favor revise en su programa contable si se han traspasado los datos de la factura que está en estado de error crítico."
      :actions="[{ 'action_text': 'Cancelar', 'emit': 'close-message' }, { 'action_text': 'Reanudar Contabilización', 'emit': 'start-accounting', 'prin': true }]" 
      :show_message="show_accounting_critical_error_msg" 
      @close-message="show_accounting_critical_error_msg = false"
      @start-accounting="startAccounting"
    ></message-popup>

 
    <message-popup 
      v-if="oauth_url"
      :message="oauth_msg" 
      :show_message="Boolean(oauth_url)" 
      :actions="[{ 'action_text': 'No', 'emit': 'close-message' }, { 'action_text': 'Si', 'emit': 'connect-user', 'prin': true }]"
      @connect-user="connectOauthUser"
      @close-message="closeSessionDialog"
    ></message-popup>

    <v-snackbar
       v-model="snackbar.isVisible"
       :color="snackbar.color"
   >
       <b>{{ snackbar.text }}</b>
   </v-snackbar>
   <TestConectorPopup
      v-if="showTestConectorPopup"
      :showTestConectorPopup="showTestConectorPopup"
      @closePopup="showTestConectorPopup = false"
    />
  </v-app>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex"
import {client, async_command_dispatcher} from "@/api/client";
import ErrorPipelinePopup from './components/ErrorPipelinePopup.vue';
import MessagePopup from './components/MessagePopup.vue';
import SelectorEmpresa from './components/SelectorEmpresa.vue';

import RightDrawerTrainerMode from "./components/RightDrawerTrainerMode.vue";
import RightDrawerClientMode from "./components/RightDrawerClientMode.vue";
import RightDrawerClientModeV2 from "./components/RightDrawerClientModeV2.vue";
import DocTextField from "./components/DocTextField"
import AccountMove from "./components/AccountMove"
import AccountMoveV2 from "./components/AccountMoveV2"
import InvoiceLines from "./components/InvoiceLines"
import Tutorial from "./components/Tutorial"
import LegalDialog from "./components/LegalDocuments/LegalDialog.vue";
import SaleTerms from "./components/LegalDocuments/SaleTerms.vue";
import SidebarElement from '@/components/layout/SidebarElement.vue';

import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "./store/vuex_utils";
import ContratoTratamientoDatos from "./components/WelcomeSteps/ContratoTratamientoDatos.vue";
import AppConfirmModal from './components/layout/AppConfirmModal.vue';
import ContractPopup from '@/components/ContractPopup.vue'
import ExtraUserContractPopup from '@/components/ExtraUserContractPopup.vue'
import PayChargePopup from '@/components/PayChargePopup.vue'
import TestConectorPopup from '@/components/TestConectorPopup.vue'
import Notifications from '@/components/Notifications.vue'
import { createApiTokenRepository } from '@/modules/tokens/infrastructure/ApiTokenRepository';
import { getOrCreateToken } from '@/modules/tokens/application/getOrCreateToken';
import { MultipleForceDownloadLoadPathFilesCommand } from "@/modules/load_path/app/MultipleForceDownloadLoadPathFiles"
import LanguageSwitcher from "./components/LanguageSwitcher.vue";
import { getLinkErrors, hasAnyError } from "@/modules/company/domain/Company";

// Mapping of Spanish texts to translation keys
const TEXT_TO_KEY_MAP = {
  "Contabilidad": "invoices",
  "Proveedores": "suppliers",
  "Clientes": "customers",
  "Bancos": "banks",
  "Factura electrónica": "electronic_invoice",
  "Gestor IA": "gestor_ia",
  "Documentos": "documents",
  "Mis Registros": "my_records",
  "Panel de Control": "dashboard",
  "Tickets": "tickets",
  "Personas": "persons",
  "Ajustes": "settings",
  "Papelera": "trash",
  "Mis Empresas": "my_companies",
  "Cuadro Resumen Gestor": "manager_summary",
  "Cuadro Resumen Contabilidad": "accounting_summary",
  "Configuración": "configuration",
  "Mis Datos": "my_data",
  "Guidelines": "guidelines",
  "Funcionalidades": "functionalities",
  "KPIs": "kpis",
  "Registro de acceso": "access_log",
  "Registro de backups": "backup_log",
  "Unidades de Red": "network_drives",
  "Novedades": "whats_new",
  "Cerrar Sesión": "log_out",
  "Usuarios": "users",
  "Ubicaciones": "locations",
  "Descargar Cliente": "download_client",
  "Información Onboard": "onboard_info",
  "Informes": "reports",
  "Cuadro Resumen Bancos": "bank_summary",
  "Contracts KPIs": "contracts_kpis",
  "Control Horario": "clock_in"
};

export default {
  name: "App",
  components:{
    ErrorPipelinePopup,
    MessagePopup,
    RightDrawerTrainerMode,
    RightDrawerClientMode,
    RightDrawerClientModeV2,
    DocTextField,
    AccountMove,
    AccountMoveV2,
    InvoiceLines,
    Tutorial,
    LegalDialog,
    SaleTerms,
    SidebarElement,
    ContratoTratamientoDatos,
    SelectorEmpresa,
    AppConfirmModal, 
    ContractPopup,
    ExtraUserContractPopup,
    PayChargePopup,
    Notifications,
    LanguageSwitcher,
    TestConectorPopup
  
    },
  provide() {
    return {
      registerRefreshFunc: this.register_refresh_func,
      runRefreshFuncs: this.run_refresh_funcs
    };
  },
  data() {
    return {
      error_move: 'white',
      drawer: true,
      companies: [],
      suppliers: [],
      customers: [],
      company: {},
      refreshFuncs: [],
      log_views_old: ['login'],
      log_views: ['signup', 'signup-2', 'password-reset', 'password-reset-key', 'confirm-email', 'install-schedule','white_brand', 'invoice-to-print', 'report-invoice', 'report-invoice-dynamic', 'report-otorgamiento'],
      welcome_views: ['welcome'],
      payment_views: ['create-contract', 'select-upgrade-create', 'upgrade-contract', 'create-upgrate-contract', 'payment-error', 'payment-ok'],
      update_views: ['update', 'performing-update', 'performing-updates'],
      settings_views: ['network-drives', 'settings'],
      no_cdb_selector_views: ['change_password','connectors','connector-update','connector-create','dashboard','locations','reports'],
      readonly_cdb_selector_views: ['supplier-update', 'customer-update', 'document-detail', 'other-doc-detail', 'invoice-editor'],
      access_registers: ['access-registers'],
      users_permissions: ['users-permissions'],
      user_configuration: ['user-configuration'],
      white_redirect: ['bank-creation', 'bank-redirect', 'stripe-result'],
      // popups_views: ['stripe-popup'],

      show_notifications_modal:false,
      domain: window.location.origin,
      whiteBrandColors: null,
      whiteBrandDomains: [
        'docuxtract.docunecta.com',
        'gscan.glasof.com',
        'portal.oxigendc.com',
        'app.novantiaeconomistas.es',
        'app.gestoriamoro.com'
      ],

      refreshAccountsState: 'done',
      refreshAccountsId: null,
      refreshAccountsArgs: {},
      intervalAccounts: null,
      isElectron:false,
      maximized:true,
      interactiveConectorStarted:false,
      forceDownloadLoading: false,
      snackbar: {
        isVisible: false,
        text: '',
        color: 'error',
      },
      showTestConectorPopup: false,
      linkErrorsWarning: {
        message: "Esta empresa tiene <b>ejercicios</b> con <b>fechas erróneas</b>.<br>Por favor, acceda a la empresa y <b>revise los ejercicios</b> para arreglar los campos erróneos.",
        tooltip: "Esta empresa tiene ejercicios con fechas erróneas.<br>Por favor, revise los ejercicios.",
      }
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle(),
      titleTemplate: null,
    }   
  },
  computed: {
    ...mapGetters([
      'availableTags',
      // 'get_companies', 
      'get_suppliers',
      'get_customers',
      'get_companydbs',
      'is_mobile',
    ]),
    ...mapGetters({
      me: 'me/me',
      userData: 'me/userData',
      useWhiteBrand: 'me/useWhiteBrand',
      hastWhiteBrandColor: 'me/hastWhiteBrandColor',
      got_feature: 'got_feature',
      isWelcomeProcess: 'me/isWelcomeProcess',
      isUpdateProcess: 'me/isUpdateProcess',
      inTutorial: 'me/inTutorial',
      defaultUsername: 'configuration/getDefaultUsername',
      forceRightBar: 'configuration/getForceRightBar',
      creatingMoves: 'accounts/creatingMoves',
      flowLoading: 'documents/flowLoading',
      documentWriting: 'documents/documentWriting',
      currentDoc: 'documents/currentDocument',
      selectedLabel: 'documents/selectedLabel',
      documentIsTrainerMode: 'documents/documentIsTrainerMode',
      currentDocuments: "documents/currentDocuments",
      currentIndex: "documents/currentIndex",
      checkSumOK: 'documents/checkSumOK',
      onAction: 'tutorial/onAction',
      fetching_companydbs:"fetching_companydbs",
      permission: 'permissions/permission',
      show_policy_privacity: 'dialog_contract/show_policy_privacity',
      show_data_treatment: 'dialog_contract/show_data_treatment', 
      show_payment_ok: 'payment_ok_modal/show',
      persistent_payment_ok: 'payment_ok_modal/persistent',
      text_payment_ok: 'payment_ok_modal/text',
      text_center_payment_ok: 'payment_ok_modal/text_center',
      text_title_payment_ok: 'payment_ok_modal/text_title',
      show_title_payment_ok: 'payment_ok_modal/show_title',
      text_confirm_button_payment_ok: 'payment_ok_modal/text_confirm_button',
      show_confirm_button_payment_ok: 'payment_ok_modal/show_confirm_button',
      show_cancel_button_payment_ok: 'payment_ok_modal/show_cancel_button',
      show_question_payment_ok: 'payment_ok_modal/show_question',
      icon_payment_ok: 'payment_ok_modal/icon',
      show_payment_error: 'payment_error_modal/show',
      persistent_payment_error: 'payment_error_modal/persistent',
      text_payment_error: 'payment_error_modal/text',
      text_center_payment_error: 'payment_error_modal/text_center',
      text_title_payment_error: 'payment_error_modal/text_title',
      show_title_payment_error: 'payment_error_modal/show_title',
      text_confirm_button_payment_error: 'payment_error_modal/text_confirm_button',
      show_confirm_button_payment_error: 'payment_error_modal/show_confirm_button',
      show_cancel_button_payment_error: 'payment_error_modal/show_cancel_button',
      show_question_payment_error: 'payment_error_modal/show_question',
      icon_payment_error: 'payment_error_modal/icon',

      showMessageModal: 'messageModal/show',
      textMessageModal: 'messageModal/text',
      textCenterMessageModal: 'messageModal/textCenter',
      textTitleMessageModal: 'messageModal/textTitle',
      showTitleMessageModal: 'messageModal/showTitle',
      textConfirmButtonMessageModal: 'messageModal/textConfirmButton',
      showConfirmButtonMessageModal: 'messageModal/showConfirmButton',
      actionConfirmButtonMessageModal: 'messageModal/actionConfirmButton',
      showCancelButtonMessageModal: 'messageModal/showCancelButton',
      textCancelButtonMessageModal: 'messageModal/textCancelButton',
      actionCancelButtonMessageModal: 'messageModal/actionCancelButton',
      showQuestionMessageModal: 'messageModal/showQuestion',
      textQuestionMessageModal: 'messageModal/textQuestion',
      iconMessageModal: 'messageModal/icon',
      persistentMessageModal: 'messageModal/persistent',
      htmlMessageModal: 'messageModal/isHtml',
    }),
    ...mapState([
      'docStates', 
      'tags', 
      'currentCompany',
      'session_information',
      'oauth_url',
      'oauth_msg',
    ]),
    ...mapFields('notifications', ['notifications']),
    ...mapFields([
      'router_name', 'zones', 'user_items', 'menu', 
      'sellTermsDialog', 'show_accounting_critical_error_msg',/**'show_contract'*/
    ]),
    ...mapFields('dialog_payment', ['show_contract_modal']),
    ...mapFields('dialog_payment', ['is_visible_extra_user_contract_popup', 'is_visible_pay_charge_popup']),
    ...mapFields('documents', ['documentListOptions', 'documentListKind', 'documentIsDebuggerMode']),
    ...mapFields('me',vuexPrefix('user_data_',['can_debug_documents', 'can_see_training_documents'],'userData.', 'doc_num', 'firm_date', 'price')),
    activeCompanyDbs() {
      let items = this.get_companydbs;
      // If feature - Do not show archived companies except the currentCompany (show it even if it's archived)
      if (this.userData.available_features['feature_archive_companies']) {
        items = items.filter(item => !item.is_archived || (this.currentCompany && item.id === this.currentCompany.id));
      }
      return items;
    },
    imgSrc() {
      let src = '/logo_blanc.png';
      if (this.is_mobile) {
        src = '/logo_blanc_short.png';
      }
      return src;
    },
    showContractModal() {
      return this.show_contract_modal && !this.white_redirect.includes(this.router_name);
    },
    showNotificationsModal() {
      return this.show_notifications_modal;
    },
    imgWidth() {
      let width = 140;
      if (this.is_mobile) {
        width = 30;
      }
      return width;
    },
    isLoginas() {
      return this.userData && this.userData.hasOwnProperty('username') && this.session_information && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username);
    },
    isStaffOrStaffLoginas() {
      // Caso 1: El usuario actual es staff
      if (this.userData && this.userData.is_staff) {
        return true;
      }
      // Caso 2: El usuario original (session_user) es staff que hizo loginas
      if (this.userData && this.userData.session_user && this.userData.session_user.is_staff) {
        return true;
      }
      return false;
    },
    isDistribuidorAvanzado() {
      // Caso 1: El usuario actual es un distribuidor avanzado
      const isCurrentUserDistribuidor = this.userData &&
             this.userData.distributor_code &&
             this.userData.available_features &&
             this.userData.available_features.feature_distribuidor_avanzado;

      // Caso 2: El usuario original (session_user) es un distribuidor avanzado que hizo loginas
      const isSessionUserDistribuidorAvanzado = this.userData &&
             this.userData.session_user &&
             this.userData.session_user.is_distribuidor_avanzado;

      // Caso 3: El usuario actual es un trabajador de distribuidor avanzado
      const isCurrentUserTrabajadorDistribuidor = this.userData &&
             this.userData.sender_docs_user_id &&
             this.userData.available_features &&
             this.userData.available_features.feature_trabajador_distribuidor_avanzado;

      // Caso 4: El usuario original (session_user) es un trabajador de distribuidor avanzado que hizo loginas
      const isSessionUserTrabajadorDistribuidorAvanzado = this.userData &&
             this.userData.session_user &&
             this.userData.session_user.is_trabajador_distribuidor_avanzado;

      return isCurrentUserDistribuidor || isSessionUserDistribuidorAvanzado ||
             isCurrentUserTrabajadorDistribuidor || isSessionUserTrabajadorDistribuidorAvanzado;
    },
    loginasDisplayText() {
      if (this.userData && this.userData.session_user &&
          this.userData.session_user.loginas_chain &&
          this.userData.session_user.loginas_chain.length > 0) {
        const chain = [this.userData.session_user.username, ...this.userData.session_user.loginas_chain];
        return chain.join(' → ');
      }
      return this.userData ? this.userData.username : '';
    },
    showAppBar(){
      let views = this.log_views.concat(this.welcome_views).concat(this.update_views).concat(this.payment_views).concat(this.log_views_old).concat(this.white_redirect);
      //console.log("views=", views);
      //console.log("route_name=", this.router_name);
      //console.log("$route.name=", this.$route.name);
      /*alert("check");*/
      return !views.includes(this.router_name);
    },
    showLeftDrawer(){
      // ['login', 'signup', 'welcome', 'update', 'create-contract', 'select-upgrade-create', 'upgrade-contract', 'performing-update', 'create-upgrate-contract', 'payment-error', 'payment-ok']
      let views = this.log_views_old.concat(this.log_views).concat(this.welcome_views).concat(this.update_views).concat(this.payment_views).concat(this.white_redirect);
      return !views.includes(this.router_name);
    },
    showRightBar(){
      return (this.router_name=='document-detail' || this.forceRightBar)
        && !this.permission.is_readonly
        && !this.is_mobile
        && !this.got_feature('feature_document_detail_split_pane');
    },
    showLegalDialog(){
      // ['login','signup','welcome','change_password','connectors','connector-update','connector-create', 'dashboard', 'create-upgrate-contract', 'payment-error', 'payment-ok', 'performing-update']
      let views = this.log_views.concat(this.log_views_old).concat(this.welcome_views).concat(this.payment_views).concat(this.no_cdb_selector_views).concat(this.white_redirect);
      return this.sellTermsDialog && !views.includes(this.router_name);
    },

    showBtnGeneric() {
      let views = this.log_views.concat(this.log_views_old).concat(this.white_redirect);
      return !views.includes(this.router_name)
    },

    showBurger(){
      return this.showBtnGeneric && this.$vuetify.breakpoint.smAndDown && this.white_redirect.includes(this.router_name)
    },
    isMini() {
      return this.$vuetify.breakpoint.mdAndUp
    },


    showCDBSelector() {
      // ['login','signup','welcome','change_password','connectors','connector-update','connector-create', 'dashboard', 'performing-update', 'network-drives', 'settings'];
      let views = ['profile'].concat(this.log_views).concat(this.log_views_old).concat(this.welcome_views).concat(this.update_views).concat(this.settings_views).concat(this.no_cdb_selector_views).concat(this.access_registers).concat(this.users_permissions).concat(this.user_configuration);
      return !views.includes(this.router_name);
    },
    isReadonlyCDBSelector() {
      return this.readonly_cdb_selector_views.includes(this.router_name);
    },
    appCustomLogo() {
      if (this.domain.includes('docuxtract.docunecta.com')) {
        return '/docunecta_logo.png'
      } else if (this.domain.includes('gscan.glasof.com')) {
        return '/gscan_logo.png'
      } else if (this.userData.logo) {
        return this.userData.logo
      }
      return null;
    },
    appBg() {
      // Mientras no hayamos podido comprobar si el usuario quiere usar marca blanca o no, mostramos el color blanco.
      let styles = {
        background: '#fff'
      }
      const primaryBlue = this.$vuetify.theme.themes.light.primary_blue
      const primary = this.$vuetify.theme.themes.light.primary
      const defaultGradient = `conic-gradient(from 148deg at 18.17% 27.57%, ${primaryBlue} 0deg, ${primary} 180.29070854187012deg, ${primaryBlue} 360deg)`
      if (!['report-invoice', 'report-invoice-dynamic', 'invoice-to-print', 'report-otorgamiento'].includes(this.router_name)) {
        // Check if this is a white brand domain
        const isWhiteBrandDomain = this.whiteBrandDomains.some(d => this.domain.includes(d))
        if (isWhiteBrandDomain) {
          // Use colors from API (already applied to Vuetify theme)
          styles = { background: defaultGradient }
        } else {
          if (this.userData.id) {
            if(this.useWhiteBrand) {
              if (this.hastWhiteBrandColor) {
                styles = { background: this.userData.white_brand_color }
              } else {
                styles = { background: defaultGradient }
              }
            } else {
              styles = { background: defaultGradient }
            }
          }
        }
      }
      return styles
    },
    showForceDownloadLoadPathFiles() {
      if (
        this.got_feature('feature_force_download_load_path') && 
        this.router_name == 'document-list' && this.permission && 
        (this.permission.general.can_admin || this.permission.is_employee) && 
        this.showCDBSelector && !this.is_mobile && this.currentCompany.id && this.currentCompany.has_cloud_load_paths
      ) {
        return true;
      }
      return false;
    },
    showCompanyAlert() {
      if (!this.currentCompany || !this.currentCompany.links) return false
      return hasAnyError(getLinkErrors(this.currentCompany.links))
    },
    showLoadPathAlert() {
      if (!this.currentCompany || !this.currentCompany.load_paths) return false
      if (this.currentCompany.load_paths.some(lp => lp.status == 'error')) return true
      return false;
    }
  },
  async mounted() {
    if(this.currentDoc){
      this.check_sum()
    }

    this.isElectron = navigator.userAgent == 'InmaticApp';
    if (this.isElectron){
      this.electronCheckInteractiveConnector();
    }

    // Fetch white brand colors for white brand domains (before login)
    if (this.whiteBrandDomains.some(d => this.domain.includes(d))) {
      await this.fetchWhiteBrandColors();
    }
  },
  methods:{
    register_refresh_func(fn) {
      this.refreshFuncs.push(fn);
    },
    run_refresh_funcs(id) {
      for (let f of this.refreshFuncs) {
        f(id);
      }
    },
    ...mapActions(['setZones']),
    ...mapActions({
      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal',
    }),
    showMessage(m, icon, isHtml){
      const modal = {
        text: m,        
        actionConfirmButton: this.closeMessageModal,
      }
      if (icon) modal.icon = icon
      if (isHtml) modal.isHtml = true
      this.setMessageModal(modal)
    },
    setSnackbar(color, text) {
      if (text != '') {
        this.snackbar.text = text;
        this.snackbar.isVisible = true;
        this.snackbar.color = color;
      }
      else {
        this.snackbar.text = '';
        this.snackbar.isVisible = false;
      }
    },
    async fetchWhiteBrandColors() {
      const { GetWhiteBrandColors } = await import('@/modules/accounts/app/GetWhiteBrandColors');
      await new GetWhiteBrandColors(this).run(this.domain);
    },
    pageTitle() {
        if (window.location.origin.includes('docuxtract.docunecta.com')){
            return 'Docunecta'
        } else if (window.location.origin.includes('gscan.glasof.com')){
            return 'GScan'
        } else if (window.location.origin.includes('portal.oxigendc.com')) {
          return 'Oxigen'
        } else if (window.location.origin.includes('app.novantiaeconomistas.es')) {
          return 'Novantia Economistas'
        } else if (window.location.origin.includes('app.gestoriamoro.com')) {
          return 'Gestoría Moro'
        } else {
            return 'Inmatic'
        }
    },
    get_color_loginas() {
      let status_color = 'var(--v-error-base)'
      if (this.userData.distributor_code) {
        status_color = '#47a73f'
      } else if (this.userData.sender_docs_user_distributor_code) {
        if (this.userData.sender_docs_user_distributor_code == 'sage_50'){
          status_color = '#f1a5fa'
        }
        else{
          status_color = '#10baf5'
        }
        
      } else if (this.userData.status == 'ACTIVE') {
        status_color = '#FFED00'
      }
      return status_color
      
    },
    getCompanies() {
      client.get('companies/').then(response => {
        this.companies = response.data;
      });
    },
    getSuppliers() {
      client.get('suppliers/').then(response => {
        this.suppliers = response.data;
      });
    },
    getCustomers() {
      client.get('customers/').then(response => {
        this.customers = response.data;
      });
    },
    set_suppliers() {
      if (this.currentDoc) {
        this.setSuppliers(this.currentDoc.companydb)
      }
      // this.setAllCurrentsFilters(false);
    },
    set_projects() {
      if (this.currentDoc)
        this.setProjects(this.currentDoc.companydb)
      else if(this.currentCompany)
        this.setProjects(this.currentCompany.id)
    },
    set_activities() {
      if (this.currentDoc)
        this.setActivities(this.currentDoc.companydb)
      else if(this.currentCompany)
        this.setActivities(this.currentCompany.id)
    },
    set_sections() {
      if (this.currentDoc)
        this.setSections(this.currentDoc.companydb)
      else if(this.currentCompany)
        this.setSections(this.currentCompany.id)
    },
    set_delegations() {
      if (this.currentDoc)
        this.setDelegations(this.currentDoc.companydb)
      else if(this.currentCompany)
        this.setDelegations(this.currentCompany.id)
    },
    set_departments() {
      if (this.currentDoc)
        this.setDepartments(this.currentDoc.companydb)
      else if(this.currentCompany)
        this.setDepartments(this.currentCompany.id)
    },
    set_customers() {
      if (this.currentDoc) {
        this.setCustomers(this.currentDoc.companydb)
      }
      
    },
    async updateCurrentCompany(new_company) {
      if(new_company){
        this.$router.push({'name': this.$router.currentRoute.name, 'params': { 'companydb_id': new_company.id }});
        await this.resetCurrentCompany({new_company: new_company})
        if (this.showCompanyAlert) {
          this.showMessage(this.linkErrorsWarning.message, null, true)
        }
      }
    },
    unset_loginas() {  
      let aux = {
        'logged_username': this.session_information.username,
        'loginas_username': this.userData.username,
      };
      this.unsetLoginas(aux).then(()=>{
        this.$router.push({'name': 'dashboard'});
        this.$router.go();
      });
    },
    change_trainer_mode() {
      this.changeTrainerMode().then(()=>{
        this.$router.push({'name': 'document-list'});
        this.$router.go();
      });
    },
    change_debugger_mode() {
      this.changeDebuggerMode().then(()=>{
        this.$router.go();
      });
    },
    startAccounting(){
      this.show_accounting_critical_error_msg = false;
      this.resumeAccounting()
    },
    openEditCompanyDB() {
      let routeData = this.$router.resolve({name: 'connector-update', params: { 'id': this.currentCompany.id }});
      window.open(routeData.href, '_blank');
    },
    electronReload(){
      window.electronAPI.reloadWindow().then(() => {
            console.log("windowReloaded")
      });
    },
    electronMinimize(){
      window.electronAPI.minimize().then(() => {
            console.log("windowMinized")
      });
    },
    electronRestore(){
      window.electronAPI.restore().then(() => {
            console.log("windowRestored")
      });
      this.maximized=false;
    },
    electronMaximize(){
      window.electronAPI.maximize().then(() => {
            console.log("windowMaximized")
      });
      this.maximized=true;
    },
    electronStartInteractiveConnector(){
      const repo = createApiTokenRepository();
      getOrCreateToken(repo).then((result) => {
        let {token} = result;
        window.electronAPI.startInteractiveConnector(token).then(() => {
          console.log("interactiveConnectorStarted")
          this.interactiveConectorStarted=true;
        });
      });
      
    },
    electronStopInteractiveConnector(){
      window.electronAPI.stopInteractiveConnector().then(() => {
            console.log("interactiveConnectorStopped")
            this.interactiveConectorStarted=false;
      });
    },
    electronCheckInteractiveConnector(){
      window.electronAPI.checkInteractiveConnector().then((response) => {
        console.log("interactiveConnectorChecked")
        this.interactiveConectorStarted=response;
      });
    },
    electronClose(){
      window.electronAPI.quit().then(() => {
            console.log("windowClosed")
      });
    },
    ...mapActions([
      'setSuppliers',
      'setCustomers',
      'setCurrentCompany',
      'unsetLoginas',
      'setProjects',
      'setActivities',
      'setSections',
      'setDelegations',
      'setDepartments',
      'changeTrainerMode',
      'changeDebuggerMode',
      'refreshData',
      'resetFilters',
      'waitForLoggedIn',
      'resetCurrentCompany',
      'setOauthUrl',
      'resumeAccounting'
    ]),
    ...mapActions({
      // setCurrentHeaders: "documents/setCurrentHeaders",
      getHeader: "documents/getHeader",
      // setAllCurrentsFilters: "documents/setAllCurrentsFilters",
      refreshUserData: "me/refreshUserData",
      setCorrectActions: "documents/setCorrectActions",
      addSimulationAction: "documents/addSimulationAction",
      addAddTagsAction: "documents/addAddTagsAction",
      addTrainingAction: "documents/addTrainingAction",
      addMarkAsErrorAccountConnectorAction: "documents/addMarkAsErrorAccountConnectorAction",
      getContractType:"me/getContractType",
      openContractModal: 'dialog_payment/openContractModal',
      closePaymentErrorModal: 'payment_error_modal/closeModal',
      closePaymentOkModal: 'payment_ok_modal/closeModal',
      refreshAccounts: "connector/refreshAccounts",
      fetchRefreshProgressState: "connector/fetchRefreshProgressState",
    }),
    closeSessionDialog() {
      this.setOauthUrl({url : null})
    },
    connectOauthUser() {
      window.location.href = this.oauth_url
      this.setOauthUrl({url : null})
    },
    refresh_accounts() {
      this.refreshAccountsState = 'pending';
      this.refreshAccounts([this.currentCompany.id]).then((response) => {
        this.refreshAccountsId = response.data.results.ids[0];
        this.intervalAccounts = setInterval(this.fetch_refresh_accounts_state, 2000);
      }).catch(err=>{
        this.refreshProgressState = 'done';
      });
    },
    fetch_refresh_accounts_state() {
      try {
        this.fetchRefreshProgressState(this.refreshAccountsId).then(response => {
          this.refreshAccountsState = response.data.state;
          this.refreshAccountsArgs = response.data.args;
          if (this.refreshAccountsState === "done") {
            clearInterval(this.intervalAccounts);
          } else if (this.refreshAccountsState === "error") {
            clearInterval(this.intervalAccounts);
          }
        });
      } catch (error) {
        console.debug(error);
        clearInterval(this.intervalAccounts);
      }
    },
    async forceDownloadLoadPath() {
      let actual_time = new Date().getTime();
      this.forceDownloadLoading = true;
      let all_ok = true;
      try {
        await new MultipleForceDownloadLoadPathFilesCommand(async_command_dispatcher).run([this.currentCompany.id], 'force_manual')
      }
      catch (error) {
        console.error('Error downloading load path files', error)
        all_ok = false;
      }
      let current_time = new Date().getTime();
      let time_diff = current_time - actual_time;
      if (time_diff < 5000) {
        await new Promise(resolve => setTimeout(resolve, 5000 - time_diff));
      }
      this.forceDownloadLoading = false;
      if (!all_ok) {
        this.setSnackbar('error', 'Ha habido un error durante el proceso.');
      }
      else {
        this.setSnackbar('success', 'Proceso de descarga iniciado.');
      }
    },
    openPopup() {
      this.showTestConectorPopup = true;
    },
    changeLanguage(text){
      return TEXT_TO_KEY_MAP[text] || "edit";
    },
    getItemDisplayText(item) {
      // Check if item has translated display names
      if (item.display_name_cat || item.display_name_en || item.display_name_es) {
        const locale = this.$i18n ? this.$i18n.locale : 'es';
        const localeMap = { 'cat': 'display_name_cat', 'en': 'display_name_en', 'es': 'display_name_es' };
        const displayNameKey = localeMap[locale] || 'display_name_es';
        if (item[displayNameKey]) {
          return item[displayNameKey];
        }
      }
      // Fallback to translation system or original text
      const key = this.changeLanguage(item.text);
      if (key === "edit") {
        return item.text;
      }
      return this.$t("App." + key);
    },
    create_autoflow_import_op(){
      client.get(`operations?order_by=id&state=pending`).then(response => {
        const operations = response.data.results;
        console.log(operations)
        for (let i = 0; i < operations.length; i++) {
          if (operations[i].name === 'Autoflow' && operations[i].companydb === this.currentCompany.id) {
            this.autoflow_import_op_id = operations[i].id;
            this.setSnackbar('error', 'Error al crear la ejecución de la importación. Es posible que tenga alguna pendiente');
            return;
          }
        }
        // Creamos OP Autoflow
        client.put('create_operation_no_staff/', {
          'params': { 'name': 'Autoflow', 'channel': 'rest', 'args': {'workflow': 'import_invoice_file'}, 'companydb': this.currentCompany.id},
        }).then(() => {
          this.setSnackbar('info', 'Ejecución de importación programada correctamente. Por favor, espere unos minutos hasta que se ejecute la importación. Puede ver el progreso en pantalla.');
        }).catch((error) => {
          console.error("Error creating autoflow import operation", error);
          this.setSnackbar('error', 'Error al crear la ejecución de la importación. Es posible que tenga alguna pendiente');
        });

      }).catch((error) => {
        console.error("Error fetching operations", error);
        this.setSnackbar('error', 'Error al comprobar si existe una operación de importación programada.');
      });

    },
    openLoadPathAlert(){
      this.showMessage(
        'Esta empresa tiene puntos de carga con errores. Por favor, acceda a la empresa y revísalos para solucionarlos. Si el error persiste, puede contactar con soporte.',
        null,
        true
      )
    }
  },
  watch: {
    onAction() {
      if (this.onAction === "OPEN_ACCOUNT") {
        this.menu = true;
        this.user_items[0].highlighted = true;
      } else {
        this.user_items[0].highlighted = false;
      }
    },
    '$route.name' (to, from) {
      if (to != from) {
        this.router_name = to;
      }
    },
    currentCompany: {
      immediate: true,
      handler(company) {
        if (company && company.available_features) {
          // If they don't have feature_simple_company_list, always force Spanish
          if (!company.available_features.feature_simple_company_list) {
            this.$i18n.locale = 'es';
            // Clear any stored locale to ensure Spanish is always used
            if (localStorage.getItem('locale') && localStorage.getItem('locale') !== 'es') {
              localStorage.setItem('locale', 'es');
            }
          } else {
            // If they have the feature, use browser language or stored preference
            if (!localStorage.getItem('locale')) {
              const userLang = navigator.language || navigator.userLanguage;
              const lang = userLang.split('-')[0];
              const supportedLang = ['en', 'es', 'cat'].includes(lang) ? lang : 'es';
              this.$i18n.locale = supportedLang;
            }
          }
        }
      }
    }
  }
};
</script>

<style>
  .v-image__image--contain{
    background-position: left !important;
  }
  .dragBar{
    -webkit-app-region: drag; 
  }
  .white__brand__logo {
    max-height: 100%
  }
  header.appBar{
    background-color: transparent !important;
    box-shadow: none !important; 
  }
  header.appBar .img-top-navigation {
    width: 24px;
    height: 24px;
    max-width: 24px;
  }

  header.appBar .img-top-navigation-mobile {
    width: 22px;
    height: 22px;
    max-width: 22px;
  }

  @media print {
    header.appBar{
      display: none;
    }

    nav.drawer {
      display: none
    }

    main.v-main {
      padding: 0px !important;
    }
  }

  .selectedrow{
    background:#eeeeee;
    border-radius:5px;
  }
  .invalid fieldset {
    background-color: #ff7777
  }
  /* .appBar {
    background: linear-gradient(270deg, #9117CC -14.56%, #8263F5 44.51%, #3CF 100%);  
  } */
  .highlighted {
    background-color: #3cf;
  }
  .title-color {
    color: var(--v-primary-base);
  }
  .list:hover {
    background: rgb(102, 51, 153, 0.1) !important;
  }
  .list:hover .list-title {
    color: var(--v-primary-base);
  }
  .drawer {
    z-index: 110;
    max-width: 50%;
  }
  .drawer.main-left-drawer {
    background-color: transparent !important;
  }
  .drawer.main-left-drawer .v-navigation-drawer__border {
    background-color: transparent !important;
  }
  @media screen and (max-width: 960px) {
    .drawer.main-left-drawer {
      background-color: #EDE7F6 !important;
    }
  }



  .right-drawer-v2 {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: -webkit-fill-available;
    margin-top: 80px;
  }

  .drawer.main-left-drawer .v-navigation-drawer__content {
    scrollbar-width: thin;
  }
  .menu {
    z-index: 101;
  }
  .btn_without_caps {
    text-transform: unset !important;
  }
  .v-icon {
    transition: none !important;
  }
  .v-icon.v-icon::after {
      transition: none !important;
  }  

  .container-full-bg-gray {
    height: 100%;
    background-color: var(--v-background-base);
    position:absolute;
    overflow-y:auto;
  }

  .container-full-bg-transaparent {
    height: 100%;
    position:absolute;
    overflow-y:auto;
    padding: 0px;
    scrollbar-width: none;
  }

  .custom-btn {
    font-weight: 500 !important;
    font-size: 0.75rem !important;
    background-color: rgba(249, 249, 249, 0.25) !important;
    font-family: Roboto;
    text-align: center;
    letter-spacing: 0;
  }

  .custom-btn:hover {
    background-color: var(--v-neutral-base) !important;
    color: var(--v-primary_blue-base) !important;
  }

  .pdf-document {
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    background-color: gray;
  };

  @font-face {
    font-family: Ubuntu;
    font-weight: 300;
    src: url('/Ubuntu-Light.ttf');
  }
  @font-face { font-family: Ubuntu; src: url('/Ubuntu-Regular.ttf'); } 
  @font-face { font-family: Ubuntu; font-weight: bold; src: url('/Ubuntu-Bold.ttf');}
  
  .icon-btn-mobile {
    padding: 0 !important;
    min-width: 0 !important;
  }

  .icon-btn-mobile .v-btn__content {
    padding: 0 !important;
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .account-menu--custom {
    max-height: 90vh;
    overflow-y: auto;
  }
</style>